import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const HtmlTooltip = styled(Tooltip)(() => ({
  tooltip: {
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 800,
    fontSize: "0.75rem", // 12px in rem
    border: "1px solid #dadde9",
  },
}));

export default HtmlTooltip;
